<template>
  <router-view />
</template>

<script>
export default {
  name: 'QuoteDistributionPassThrough',
}
</script>
